import React from 'react';

import { SVGIcon } from '../../UIKit/index';

export default function DCInstaReports1(props) {
    return (
        <SVGIcon {...props} viewBox="0 0 503.71 412.095">
            <g id="InstaReports" transform="translate(-3.91 -52.525)">
                <ellipse
                    id="_Path_"
                    data-name="&lt;Path&gt;"
                    cx="232.01"
                    cy="29.06"
                    rx="232.01"
                    ry="29.06"
                    transform="translate(11.01 406.5)"
                    fill="#f4f5f6"
                />
                <rect
                    id="Rectangle_1"
                    data-name="Rectangle 1"
                    width="210.78"
                    height="151.31"
                    transform="translate(93.64 62.27)"
                    fill="#fafbfb"
                />
                <path
                    id="Path_1"
                    data-name="Path 1"
                    d="M292.42,213.58,238.81,62.27H198.58l53.61,151.31Z"
                    fill="#fff"
                />
                <path
                    id="Path_2"
                    data-name="Path 2"
                    d="M184.24,213.58,130.62,62.27H115.95l53.61,151.31Z"
                    fill="#fff"
                />
                <path
                    id="Path_3"
                    data-name="Path 3"
                    d="M83.59,57.06H314.47a.94.94,0,0,1,.93.94h0a.94.94,0,0,1-.93.94H83.59a1,1,0,0,1-.94-.94h0a.94.94,0,0,1,.94-.94Z"
                    fill="#e4e3e3"
                />
                <rect
                    id="Rectangle_2"
                    data-name="Rectangle 2"
                    width="2.5"
                    height="151.96"
                    transform="translate(197.78 61.94)"
                    fill="#e4e3e3"
                />
                <rect
                    id="Rectangle_3"
                    data-name="Rectangle 3"
                    width="1.25"
                    height="151.96"
                    transform="translate(196.53 61.94)"
                    fill="#e4e3e3"
                />
                <rect
                    id="Rectangle_4"
                    data-name="Rectangle 4"
                    width="2.5"
                    height="213.69"
                    transform="translate(92.19 139.17) rotate(-90)"
                    fill="#f1f0f0"
                />
                <path
                    id="Path_4"
                    data-name="Path 4"
                    d="M92.18,212.54h0V60.81H305.87V212.54h0V215H92.18Zm211.2,0V63.31H94.68V212.54Z"
                    fill="#e4e3e3"
                />
                <rect
                    id="Rectangle_5"
                    data-name="Rectangle 5"
                    width="1.25"
                    height="154.23"
                    transform="translate(90.93 60.81)"
                    fill="#e4e3e3"
                />
                <path
                    id="Path_5"
                    data-name="Path 5"
                    d="M123.17,54.77v177.7H78.06l8.27-177.7Z"
                    fill="#e4e3e3"
                    opacity="0.5"
                />
                <path
                    id="Path_6"
                    data-name="Path 6"
                    d="M273.64,54.77v177.7h45.11l-8.27-177.7Z"
                    fill="#e4e3e3"
                    opacity="0.5"
                />
                <rect
                    id="Rectangle_6"
                    data-name="Rectangle 6"
                    width="17.21"
                    height="139.56"
                    transform="translate(46.85 253.76)"
                    fill="#e4e3e3"
                />
                <rect
                    id="Rectangle_7"
                    data-name="Rectangle 7"
                    width="189.56"
                    height="5.22"
                    transform="translate(50.15 393.32)"
                    fill="#f1f0f0"
                />
                <rect
                    id="Rectangle_8"
                    data-name="Rectangle 8"
                    width="178.96"
                    height="139.56"
                    transform="translate(243.02 393.32) rotate(180)"
                    fill="#f4f5f6"
                />
                <rect
                    id="Rectangle_9"
                    data-name="Rectangle 9"
                    width="17.59"
                    height="4.55"
                    transform="translate(44.68 249.21)"
                    fill="#e4e3e3"
                />
                <rect
                    id="Rectangle_10"
                    data-name="Rectangle 10"
                    width="182.91"
                    height="4.55"
                    transform="translate(245.18 253.75) rotate(180)"
                    fill="#e4e3e3"
                />
                <path
                    id="Path_7"
                    data-name="Path 7"
                    d="M236.83,332.3H70.24v-69H236.83ZM71.39,331.14H235.67V264.47H71.39Z"
                    fill="#e4e3e3"
                />
                <path
                    id="Path_8"
                    data-name="Path 8"
                    d="M236.83,383.76H70.24V339.21H236.83ZM71.39,382.61H235.67V340.36H71.39Z"
                    fill="#e4e3e3"
                />
                <rect
                    id="Rectangle_11"
                    data-name="Rectangle 11"
                    width="121.7"
                    height="3.7"
                    rx="1.4"
                    transform="translate(92.68 263.9)"
                    fill="#e4e3e3"
                />
                <rect
                    id="Rectangle_12"
                    data-name="Rectangle 12"
                    width="121.7"
                    height="3.7"
                    rx="1.4"
                    transform="translate(92.68 339.78)"
                    fill="#e4e3e3"
                />
                <rect
                    id="Rectangle_13"
                    data-name="Rectangle 13"
                    width="100.09"
                    height="305.39"
                    transform="translate(459.11 391.85) rotate(180)"
                    fill="#e8e8e8"
                />
                <rect
                    id="Rectangle_14"
                    data-name="Rectangle 14"
                    width="3.18"
                    height="305.39"
                    transform="translate(355.85 86.45)"
                    fill="#e4e3e3"
                />
                <rect
                    id="Rectangle_15"
                    data-name="Rectangle 15"
                    width="67.61"
                    height="282.09"
                    transform="translate(442.87 380.2) rotate(180)"
                    fill="#fff"
                />
                <path
                    id="Path_9"
                    data-name="Path 9"
                    d="M135.75,425.98l8.55-3.24-5.23-20.66-8.55,3.24Z"
                    fill="#e4e3e3"
                />
                <path
                    id="Path_10"
                    data-name="Path 10"
                    d="M71.52,426.15h9.15l1.37-21.17H72.89Z"
                    fill="#e4e3e3"
                />
                <path
                    id="Path_11"
                    data-name="Path 11"
                    d="M81.58,425.09H70.44a.75.75,0,0,0-.75.62l-1.4,8.13a1.42,1.42,0,0,0,1.41,1.63c3.59-.07,6.19-.28,10.71-.28,2.78,0,11.17.29,15,.29s4.15-3.79,2.56-4.14c-7.12-1.54-12.53-3.66-14.89-5.69a2.33,2.33,0,0,0-1.5-.56Z"
                    fill="#555656"
                />
                <path
                    id="Path_12"
                    data-name="Path 12"
                    d="M143.87,421.77l-9.34,3.54a.81.81,0,0,0-.51.86l1.2,8.24a1.33,1.33,0,0,0,1.8,1.06c3.35-1.34,6.19-3,10.45-4.56a71.989,71.989,0,0,0,14-6.27c3.16-2,1.83-5.83.34-5.24-6.8,2.73-8.46,3.63-15.59,2.26a4.21,4.21,0,0,0-2.35.11Z"
                    fill="#555656"
                />
                <path
                    id="Path_13"
                    data-name="Path 13"
                    d="M119.75,147.53c2.88,5.09,5.91,10.33,9,15.4s6.19,10.12,9.52,14.84c.81,1.2,1.7,2.34,2.5,3.45a3.34,3.34,0,0,0,.71.82,2.71,2.71,0,0,0,1.66.26,11.36,11.36,0,0,0,3.06-.73,37.72,37.72,0,0,0,7.05-3.69c1.17-.77,2.37-1.57,3.54-2.42s2.35-1.77,3.41-2.59l5.13,4.56a48.328,48.328,0,0,1-3,3.9,42.959,42.959,0,0,1-3.31,3.62,41.929,41.929,0,0,1-3.75,3.35,31.7,31.7,0,0,1-4.4,3,21.91,21.91,0,0,1-5.55,2.26,15,15,0,0,1-7.38,0,13.88,13.88,0,0,1-6.72-4.25c-1.1-1.27-2.17-2.46-3.17-3.71a175.222,175.222,0,0,1-11-15.34c-3.37-5.27-6.49-10.54-9.44-16.14Z"
                    fill="#e4e3e3"
                />
                <path
                    id="Path_14"
                    data-name="Path 14"
                    d="M103.53,148c-2.46,8.39,14.89,31.25,14.89,31.25l17.5-11.26s-5.14-11.66-12.13-20.56C116.62,138.25,106.24,138.75,103.53,148Z"
                    fill="#707272"
                />
                <path
                    id="Path_15"
                    data-name="Path 15"
                    d="M103.53,148c-2.46,8.39,14.89,31.25,14.89,31.25l17.5-11.26s-5.14-11.66-12.13-20.56C116.62,138.25,106.24,138.75,103.53,148Z"
                    fill="#707272"
                    opacity="0.2"
                />
                <path
                    id="Path_16"
                    data-name="Path 16"
                    d="M114.2,157.8c3.6,1.53,8.89,10.2,11.65,16.63l-7.43,4.77a140.771,140.771,0,0,1-11.16-17.5C109.61,159.13,112.3,157,114.2,157.8Z"
                    opacity="0.2"
                />
                <path
                    id="Path_17"
                    data-name="Path 17"
                    d="M159.09,175.72l3.21-9,9.09,4.34s-1.88,8-8.54,8Z"
                    fill="#e4e3e3"
                />
                <path
                    id="Path_18"
                    data-name="Path 18"
                    d="M170.39,160.82l3.85,4.26-2.85,6-9.1-4.34Z"
                    fill="#e4e3e3"
                />
                <path
                    id="Path_19"
                    data-name="Path 19"
                    d="M139.07,402.09l2.7,10.65-8.56,3.24-2.7-10.65Z"
                    opacity="0.2"
                />
                <path
                    id="Path_20"
                    data-name="Path 20"
                    d="M72.89,404.98h9.15l-.71,10.91H72.18Z"
                    opacity="0.2"
                />
                <path
                    id="Path_21"
                    data-name="Path 21"
                    d="M62.78,144.24C72.63,179,71,215.82,71.63,223.31l48.87-1.83c8.3-51.77-6.61-80.58-6.61-80.58s-3.13-.61-7.4-1.05c-1.34-.14-2.78-.26-4.28-.34-.83,0-1.67-.07-2.53-.09A183.3,183.3,0,0,0,79,141c-1.3.17-2.62.36-3.9.57s-2.36.42-3.45.64C66.62,143.16,62.78,144.24,62.78,144.24Z"
                    fill="#707272"
                />
                <path
                    id="Path_22"
                    data-name="Path 22"
                    d="M62.78,144.24C72.63,179,71,215.82,71.63,223.31l48.87-1.83c8.3-51.77-6.61-80.58-6.61-80.58s-3.13-.61-7.4-1.05c-1.34-.14-2.78-.26-4.28-.34-.83,0-1.67-.07-2.53-.09A183.3,183.3,0,0,0,79,141c-1.3.17-2.62.36-3.9.57s-2.36.42-3.45.64C66.62,143.16,62.78,144.24,62.78,144.24Z"
                    fill="#707272"
                    opacity="0.2"
                />
                <path
                    id="Path_23"
                    data-name="Path 23"
                    d="M73.18,159.14c.88,3.36-.12,18.69-3.63,22.47-.48-4.91-1.12-10-2-15.27Z"
                    opacity="0.2"
                />
                <path
                    id="Path_24"
                    data-name="Path 24"
                    d="M79.27,117.47c1.8,6.57,4,18.69-.32,23.49,3.9,3.34,8.94,7.15,16.89,6.84s6.15-5.66,3.84-8.38c-7.57-1.22-7.79-6.76-6.88-12Z"
                    fill="#e4e3e3"
                />
                <path
                    id="Path_25"
                    data-name="Path 25"
                    d="M96.04,146.66l1.44.98-5.26,1.53,1.35-2.43Z"
                    fill="#e4e3e3"
                />
                <path
                    id="Path_26"
                    data-name="Path 26"
                    d="M98.02,146.15l-.54,1.49,5.28,1.53-.35-2.82Z"
                    fill="#e4e3e3"
                />
                <path
                    id="Path_27"
                    data-name="Path 27"
                    d="M75.79,140.46l2.08-1.05a2,2,0,0,1,2.09.18A41.71,41.71,0,0,0,96,146.67c-4.18,2-3.14,7.34-3.14,7.34s-13.27-4.38-17.53-12.3a.93.93,0,0,1,.46-1.25Z"
                    fill="#fff"
                />
                <path
                    id="Path_28"
                    data-name="Path 28"
                    d="M102,139.08l-3-.46a.41.41,0,0,0-.39.64c1.07,1.51,2.84,4.85-.54,6.89,4.18,2,5.48,6.87,5.48,6.87s5.44-5.86-.9-13.6A1,1,0,0,0,102,139.08Z"
                    fill="#fff"
                />
                <path
                    id="Path_29"
                    data-name="Path 29"
                    d="M84.79,121.52l8,5.86a21.719,21.719,0,0,0-.37,3.73c-2.87-.2-7-3-7.53-6a10,10,0,0,1-.1-3.59Z"
                    fill="#555656"
                    opacity="0.5"
                />
                <path
                    id="Path_30"
                    data-name="Path 30"
                    d="M102.47,104c-.37,3.17-3.41,5.91-5.39,6.59L94.63,96.76C100.14,92.87,103,99.53,102.47,104Z"
                    fill="#555656"
                />
                <path
                    id="Path_31"
                    data-name="Path 31"
                    d="M76.51,107.8c1.59,8.93,2.06,14.24,7.14,18.34,7.63,6.16,18.26.76,19.38-8.47,1-8.31-1.77-21.52-11-24.09A12.38,12.38,0,0,0,76.51,107.8Z"
                    fill="#e4e3e3"
                />
                <path
                    id="Path_32"
                    data-name="Path 32"
                    d="M78.2,113.82c4.14,2.2,6-2.74,6-4.74.06-3.19-1.33-6.69-3-8,8,0,23.79-.4,19.8-8S89,86.34,83,90.5c-3.18,2.2-13.47.29-10.92,6.22C66.77,99.59,71.42,110.22,78.2,113.82Z"
                    fill="#555656"
                />
                <path
                    id="Path_33"
                    data-name="Path 33"
                    d="M73,96.25a6.59,6.59,0,0,1-4-1.34,3.75,3.75,0,0,0,3.49,2.89Z"
                    fill="#555656"
                />
                <path
                    id="Path_34"
                    data-name="Path 34"
                    d="M73.15,115.15a8.66,8.66,0,0,0,5,4.31c2.88.93,3.54-1.71,2.84-4.49-.63-2.5-2-5.91-4.92-5.63S71.91,112.64,73.15,115.15Z"
                    fill="#e4e3e3"
                />
                <path
                    id="Path_35"
                    data-name="Path 35"
                    d="M131.14,318.13c-3.71-27.65-10.64-96.65-10.64-96.65l-32.13,1.2s15.15,69,20.64,96.91S129.74,415,129.74,415l14.48-5.48S135,346.89,131.14,318.13Z"
                    fill="#555656"
                />
                <path
                    id="Path_36"
                    data-name="Path 36"
                    d="M100.37,241.27a17,17,0,0,0-7.14,3.66c3,13.94,7,32.29,10.39,48.46C106,279.38,106,253,100.37,241.27Z"
                    opacity="0.2"
                />
                <path
                    id="Path_37"
                    data-name="Path 37"
                    d="M103.16,222.13S96.35,297,93.23,323.58c-3.42,29.14-7.69,90.2-7.69,90.2H68.79s-.69-54,1.48-82.52c2.48-32.49,1.36-107.94,1.36-107.94Z"
                    fill="#555656"
                />
                <path
                    id="Path_38"
                    data-name="Path 38"
                    d="M87.76,414.14H68.05l-.42-5.89,22.01-.38Z"
                    fill="#707272"
                />
                <path
                    id="Path_39"
                    data-name="Path 39"
                    d="M146.17,409.19l-17.25,6.55-2.12-5.58,19.17-7.6Z"
                    fill="#707272"
                />
                <path
                    id="Path_40"
                    data-name="Path 40"
                    d="M90.44,108.74c.09.74.54,1.28,1,1.23s.8-.69.72-1.43-.54-1.28-1-1.22S90.36,108,90.44,108.74Z"
                    fill="#555656"
                />
                <path
                    id="Path_41"
                    data-name="Path 41"
                    d="M98.72,107.79c.09.73.54,1.28,1,1.23s.8-.7.72-1.43-.54-1.28-1-1.23S98.64,107.06,98.72,107.79Z"
                    fill="#555656"
                />
                <path
                    id="Path_42"
                    data-name="Path 42"
                    d="M96.13,108.46a26.74,26.74,0,0,0,4.22,5.86c-1.15,1.36-3.42,1.06-3.42,1.06Z"
                    fill="#555656"
                    opacity="0.5"
                />
                <path
                    id="Path_43"
                    data-name="Path 43"
                    d="M94.07,117.69a6.1,6.1,0,0,1-4.42-1.92.216.216,0,1,1,.31-.3,5.82,5.82,0,0,0,5,1.73.21.21,0,0,1,.24.19.22.22,0,0,1-.19.24,6.369,6.369,0,0,1-.94.06Z"
                    fill="#555656"
                />
                <path
                    id="Path_44"
                    data-name="Path 44"
                    d="M87.58,106.36a.42.42,0,0,1-.21-.06.43.43,0,0,1-.15-.59,4.3,4.3,0,0,1,3.3-2.18.43.43,0,0,1,.45.41.45.45,0,0,1-.41.46h0a3.41,3.41,0,0,0-2.6,1.75.41.41,0,0,1-.38.21Z"
                    fill="#555656"
                />
                <path
                    id="Path_45"
                    data-name="Path 45"
                    d="M102,104.53a.41.41,0,0,1-.35-.2A3.5,3.5,0,0,0,99,102.66a.43.43,0,1,1,0-.86,4.29,4.29,0,0,1,3.37,2.06.43.43,0,0,1-.14.6.4.4,0,0,1-.23.07Z"
                    fill="#555656"
                />
                <path
                    id="Path_46"
                    data-name="Path 46"
                    d="M84.68,426.69a11.118,11.118,0,0,1-2.4-.33.22.22,0,0,1-.09-.4c.32-.2,3.18-2,4.22-1.5a.75.75,0,0,1,.4.62,1.22,1.22,0,0,1-.39,1.14A2.66,2.66,0,0,1,84.68,426.69Zm-1.79-.64c1.57.31,2.76.26,3.24-.16a.85.85,0,0,0,.25-.79.27.27,0,0,0-.15-.25C85.69,424.58,84.05,425.36,82.89,426.05Z"
                    fill="#5274b8"
                />
                <path
                    id="Path_47"
                    data-name="Path 47"
                    d="M82.33,426.36a.24.24,0,0,1-.12,0,.23.23,0,0,1-.11-.2c0-.11.09-2.75,1.11-3.62a1.16,1.16,0,0,1,.91-.28h0a.78.78,0,0,1,.72.57c.24,1-1.49,3-2.41,3.54Zm1.66-3.7a.72.72,0,0,0-.49.19c-.65.55-.87,2.09-.94,2.86.91-.71,2-2.23,1.85-2.83,0-.05,0-.18-.32-.22H84Z"
                    fill="#5274b8"
                />
                <path
                    id="Path_48"
                    data-name="Path 48"
                    d="M145.15,422.63a.2.2,0,0,1-.19-.11.21.21,0,0,1,0-.25c.31-.34,3.09-3.39,4.34-3.21a.69.69,0,0,1,.54.42h0a1.22,1.22,0,0,1,0,1.13c-.63,1.18-3.2,1.77-4.69,2Zm4-3.14c-.73,0-2.32,1.44-3.43,2.6,2-.4,3.38-1,3.73-1.69a.78.78,0,0,0,0-.74.28.28,0,0,0-.21-.17Z"
                    fill="#5274b8"
                />
                <path
                    id="Path_49"
                    data-name="Path 49"
                    d="M145.15,422.63h-.06a.23.23,0,0,1-.15-.15c0-.11-.67-2.5.08-3.8a1.56,1.56,0,0,1,1-.77h0a.812.812,0,0,1,1,.28c.52.9-.82,3.53-1.68,4.38a.2.2,0,0,1-.19.06Zm1.19-4.34h-.22a1.19,1.19,0,0,0-.73.57,5.16,5.16,0,0,0-.13,3.07c.82-1,1.66-3,1.34-3.56A.35.35,0,0,0,146.34,418.29Zm-.28-.18Z"
                    fill="#5274b8"
                />
                <path
                    id="Path_50"
                    data-name="Path 50"
                    d="M72.83,157.17c-2.74,5.65-5.54,11.48-8.25,17.22-1.34,2.89-2.69,5.77-4,8.66l-1.9,4.34-.9,2.17-.23.54-.16.4c-.11.26-.18.52-.28.78a13.22,13.22,0,0,0-.35,6.64,22.65,22.65,0,0,0,2.87,7.26,45.25,45.25,0,0,0,5.2,7c1,1.13,2,2.25,3.13,3.31.54.54,1.1,1.06,1.67,1.57s1.16,1.05,1.64,1.47l-3.64,5.82a44.491,44.491,0,0,1-4.58-2.68c-1.45-1-2.87-2-4.25-3.06a47.18,47.18,0,0,1-7.63-7.59,32.17,32.17,0,0,1-5.52-10.22,24.65,24.65,0,0,1-.52-12.64c.13-.52.24-1,.41-1.56l.42-1.35.77-2.41c.54-1.58,1.07-3.18,1.66-4.74,1.15-3.13,2.35-6.23,3.64-9.29,2.55-6.14,5.31-12.06,8.43-18Z"
                    fill="#e4e3e3"
                />
                <path
                    id="Path_51"
                    data-name="Path 51"
                    d="M62.78,144.24c-8.34,2.62-16.54,30.9-16.54,30.9l19.3,8.45s6.24-13.67,9.83-24.38C79.28,147.54,72.89,141.08,62.78,144.24Z"
                    fill="#707272"
                />
                <path
                    id="Path_52"
                    data-name="Path 52"
                    d="M62.78,144.24c-8.34,2.62-16.54,30.9-16.54,30.9l19.3,8.45s6.24-13.67,9.83-24.38C79.28,147.54,72.89,141.08,62.78,144.24Z"
                    fill="#707272"
                    opacity="0.2"
                />
                <path
                    id="Path_53"
                    data-name="Path 53"
                    d="M69.27,216.78l8,4.74-7.76,7.73s-6.74-5.19-4.73-9.25Z"
                    fill="#e4e3e3"
                />
                <path
                    id="Path_54"
                    data-name="Path 54"
                    d="M82.58,229.09l-8,5.6-5.09-5.44,7.76-7.73Z"
                    fill="#e4e3e3"
                />
                <rect
                    id="Rectangle_16"
                    data-name="Rectangle 16"
                    width="5.28"
                    height="1.09"
                    transform="translate(468.381 219.983) rotate(-85.86)"
                    fill="#707272"
                />
                <rect
                    id="Rectangle_17"
                    data-name="Rectangle 17"
                    width="15.3"
                    height="1.09"
                    transform="translate(469.086 210.066) rotate(-85.86)"
                    fill="#707272"
                />
                <path
                    id="Path_55"
                    data-name="Path 55"
                    d="M440.33,366.4H172.91a13.68,13.68,0,0,1-13.79-14.86l14.14-197.39a16.28,16.28,0,0,1,15.93-14.86H456.6a13.69,13.69,0,0,1,13.8,14.86L456.25,351.54a16.27,16.27,0,0,1-15.92,14.86Z"
                    fill="#707272"
                />
                <path
                    id="Path_56"
                    data-name="Path 56"
                    d="M378.12,435.49h-86.8L275.85,328.23h86.8Z"
                    fill="#707272"
                />
                <path
                    id="Path_57"
                    data-name="Path 57"
                    d="M364.34,429.09h-93.9l-1.86,6.4h93.89Z"
                    fill="#555656"
                />
                <path
                    id="Path_58"
                    data-name="Path 58"
                    d="M367.23,379.86l-84.6-4.62-6.78-47.01h83.93Z"
                    opacity="0.5"
                />
                <path
                    id="Path_59"
                    data-name="Path 59"
                    d="M437.31,366.4H169.89a13.68,13.68,0,0,1-13.79-14.86l14.15-197.39a16.27,16.27,0,0,1,15.92-14.86H453.59a13.69,13.69,0,0,1,13.79,14.86L453.23,351.54a16.27,16.27,0,0,1-15.92,14.86Z"
                    fill="#555656"
                />
                <rect
                    id="Rectangle_18"
                    data-name="Rectangle 18"
                    width="113.53"
                    height="1.04"
                    transform="translate(458.565 269.293) rotate(-85.9)"
                    fill="#f4f5f6"
                />
                <rect
                    id="Rectangle_19"
                    data-name="Rectangle 19"
                    width="39.406"
                    height="1.043"
                    transform="translate(455.195 316.798) rotate(-85.996)"
                    fill="#f4f5f6"
                />
                <path
                    id="Path_60"
                    data-name="Path 60"
                    d="M436.74,362.71H171a10.65,10.65,0,0,1-10.73-11.57l14.09-196.59A12.66,12.66,0,0,1,186.73,143H452.49a10.65,10.65,0,0,1,10.74,11.56l-14.1,196.59a12.66,12.66,0,0,1-12.39,11.56Z"
                    fill="#fff"
                />
                <path
                    id="Path_61"
                    data-name="Path 61"
                    d="M436.74,362.71H171a10.65,10.65,0,0,1-10.73-11.57l14.09-196.59A12.66,12.66,0,0,1,186.73,143H452.49a10.65,10.65,0,0,1,10.74,11.56l-14.1,196.59a12.66,12.66,0,0,1-12.39,11.56Z"
                    fill="#fff"
                />
                <path
                    id="Path_62"
                    data-name="Path 62"
                    d="M239.15,354H177.09a5.14,5.14,0,0,1-5.19-5.58L185.6,157.3a6.12,6.12,0,0,1,6-5.59h62.06a5.15,5.15,0,0,1,5.19,5.59l-13.7,191.12A6.11,6.11,0,0,1,239.15,354Z"
                    fill="#f4f5f6"
                />
                <path
                    id="Path_63"
                    data-name="Path 63"
                    d="M236.75,178.64H204.63a4.63,4.63,0,0,1-4.67-5l.35-4.92a5.51,5.51,0,0,1,5.39-5h32.12a4.65,4.65,0,0,1,4.68,5l-.36,4.92a5.5,5.5,0,0,1-5.39,5Z"
                    fill="#e4e3e3"
                />
                <path
                    id="Path_64"
                    data-name="Path 64"
                    d="M216.33,256H167.28a8.09,8.09,0,0,1-8.15-8.78l3.52-49a9.62,9.62,0,0,1,9.41-8.78h49a8.08,8.08,0,0,1,8.15,8.78l-3.52,49a9.61,9.61,0,0,1-9.36,8.78Z"
                    fill="#707272"
                />
                <path
                    id="Path_65"
                    data-name="Path 65"
                    d="M223.36,215.75a3.66,3.66,0,0,0-3.59,3.34l-.51,7.12a3.09,3.09,0,0,0,3.11,3.35h5a.9.9,0,0,0,.89-.83l.88-12.15a.77.77,0,0,0-.77-.83Z"
                    fill="#f4f5f6"
                />
                <path
                    id="Path_66"
                    data-name="Path 66"
                    d="M204.43,201.83H173.52a1.23,1.23,0,0,1-1.24-1.34h0a1.46,1.46,0,0,1,1.44-1.34h30.91a1.23,1.23,0,0,1,1.24,1.34h0a1.46,1.46,0,0,1-1.44,1.34Z"
                    fill="#f4f5f6"
                />
                <path
                    id="Path_67"
                    data-name="Path 67"
                    d="M203.94,208.66H173a1.24,1.24,0,0,1-1.24-1.34h0a1.46,1.46,0,0,1,1.44-1.34h30.91a1.22,1.22,0,0,1,1.24,1.34h0a1.46,1.46,0,0,1-1.41,1.34Z"
                    fill="#f4f5f6"
                />
                <path
                    id="Path_68"
                    data-name="Path 68"
                    d="M192.77,215.49H172.54a1.24,1.24,0,0,1-1.24-1.34h0a1.46,1.46,0,0,1,1.44-1.34H193a1.23,1.23,0,0,1,1.24,1.34h0a1.46,1.46,0,0,1-1.47,1.34Z"
                    fill="#f4f5f6"
                />
                <path
                    id="Path_69"
                    data-name="Path 69"
                    d="M204.52,248H174.61a5.29,5.29,0,0,1-5.33-5.74l1.13-15.71a6.27,6.27,0,0,1,6.15-5.74h29.9a5.28,5.28,0,0,1,5.33,5.74l-1.12,15.71a6.29,6.29,0,0,1-6.15,5.74Z"
                    fill="#e4e3e3"
                />
                <path
                    id="Path_70"
                    data-name="Path 70"
                    d="M232.44,274.32H195.23a2.29,2.29,0,0,1-2.31-2.49h0a2.71,2.71,0,0,1,2.66-2.49h37.21a2.29,2.29,0,0,1,2.31,2.49h0a2.73,2.73,0,0,1-2.66,2.49Z"
                    fill="#707272"
                />
                <path
                    id="Path_71"
                    data-name="Path 71"
                    d="M224.94,284.09H201.32A2.3,2.3,0,0,1,199,281.6h0a2.73,2.73,0,0,1,2.67-2.49h23.61a2.29,2.29,0,0,1,2.31,2.49h0a2.71,2.71,0,0,1-2.65,2.49Z"
                    fill="#e4e3e3"
                />
                <path
                    id="Path_72"
                    data-name="Path 72"
                    d="M230.5,301.27H193.29a2.3,2.3,0,0,1-2.31-2.49h0a2.73,2.73,0,0,1,2.67-2.48h37.21a2.29,2.29,0,0,1,2.31,2.48h0A2.73,2.73,0,0,1,230.5,301.27Z"
                    fill="#707272"
                />
                <path
                    id="Path_73"
                    data-name="Path 73"
                    d="M223,311H199.39a2.29,2.29,0,0,1-2.31-2.49h0a2.73,2.73,0,0,1,2.67-2.49h23.61a2.29,2.29,0,0,1,2.31,2.49h0A2.73,2.73,0,0,1,223,311Z"
                    fill="#e4e3e3"
                />
                <path
                    id="Path_74"
                    data-name="Path 74"
                    d="M228.57,328.23H191.36a2.29,2.29,0,0,1-2.31-2.49h0a2.73,2.73,0,0,1,2.67-2.49h37.21a2.29,2.29,0,0,1,2.31,2.49h0a2.73,2.73,0,0,1-2.67,2.49Z"
                    fill="#707272"
                />
                <rect
                    id="Rectangle_20"
                    data-name="Rectangle 20"
                    width="28.59"
                    height="4.98"
                    rx="2.49"
                    transform="translate(195.15 333.02)"
                    fill="#e4e3e3"
                />
                <path
                    id="Path_75"
                    data-name="Path 75"
                    d="M439.63,298c1.61-2.46,5.31-1.42,5.1,1.43l-3.58,49.95C441,351.9,439,354,436.82,354h-180c-2.2,0-3.85-2.09-3.66-4.66l2.12-29.68a6.44,6.44,0,0,1,8.11-5.71c10.14,3.16,18.83,1.3,26.91-2.7,17.28-8.58,31.73-27,51.59-27,.76,0,1.51,0,2.24.07,29.55,1.78,38.55,38.48,61.44,38.48,6.76,0,12.93-2.92,18.31-7.08C430.5,310.62,435.87,303.67,439.63,298Z"
                    fill="#e4e3e3"
                />
                <path
                    id="Path_76"
                    data-name="Path 76"
                    d="M443.36,318.53l-2.21,30.8C441,351.9,439,354,436.82,354h-180c-2.2,0-3.85-2.09-3.66-4.66l4.38-61.2c.3-4.2,5.8-6,8-2.57,5.74,8.76,14.58,20.08,24.74,25.68a25.26,25.26,0,0,0,12.16,3.44c14.54,0,26.91-17.25,41.67-30.36,9.06-8,19-14.52,30.93-14.52,24.86,0,28.53,40.39,48.82,45.92,3.91,1.07,8.44.84,13.86-1.24a4,4,0,0,1,5.64,4.04Z"
                    fill="#e4e3e3"
                    opacity="0.5"
                />
                <path
                    id="Path_77"
                    data-name="Path 77"
                    d="M444.24,306.59a.38.38,0,0,1-.26-.11.25.25,0,0,1-.08-.12.35.35,0,0,1,0-.14.33.33,0,0,1,.1-.22.37.37,0,0,1,.52,0,.31.31,0,0,1,.11.26.681.681,0,0,1,0,.14.269.269,0,0,1-.09.12.35.35,0,0,1-.3.07Z"
                    fill="#707272"
                />
                <path
                    id="Path_78"
                    data-name="Path 78"
                    d="M269.26,332.17a.36.36,0,0,1-.37-.37h0a.36.36,0,0,1,.37-.36h0a.37.37,0,0,1,.37.37h0a.37.37,0,0,1-.37.38h0Zm-3.74-.21h0a.36.36,0,0,1-.34-.4h0a.37.37,0,0,1,.41-.33h0a.37.37,0,0,1,.33.41h0a.38.38,0,0,1-.37.34h0Zm7.06-.32a.37.37,0,0,1,.33-.42h0a.37.37,0,0,1,.41.33h0a.37.37,0,0,1-.33.41h0A.37.37,0,0,1,272.58,331.64Zm-10.75-.24a.4.4,0,0,1-.3-.45h0a.39.39,0,0,1,.45-.3h0a.39.39,0,0,1,.29.45h0a.37.37,0,0,1-.37.3h-.07Zm14.4-.37a.36.36,0,0,1,.27-.46h0a.37.37,0,0,1,.45.27h0a.39.39,0,0,1-.28.46h-.08a.35.35,0,0,1-.36-.3Zm119.4.15a.38.38,0,0,1-.37-.37h0a.38.38,0,0,1,.37-.37h0a.37.37,0,0,1,.38.37h0a.38.38,0,0,1-.38.37Zm3.33-.53a.37.37,0,0,1,.33-.4h0a.37.37,0,0,1,.42.33h0a.37.37,0,0,1-.34.41h0a.39.39,0,0,1-.37-.34Zm-7.06.3a.37.37,0,0,1-.32-.42h0a.38.38,0,0,1,.42-.32h0a.38.38,0,0,1,.33.41h0a.39.39,0,0,1-.38.34h-.05Zm-133.7-.45a.37.37,0,0,1-.26-.46h0a.39.39,0,0,1,.47-.26h0a.39.39,0,0,1,.25.47h0a.37.37,0,0,1-.36.26h-.1Zm144.43-.36a.37.37,0,0,1,.3-.44h0a.37.37,0,0,1,.43.3h0a.36.36,0,0,1-.29.44H403a.39.39,0,0,1-.37-.3Zm-14.4.13a.35.35,0,0,1-.27-.45h0a.38.38,0,0,1,.45-.27h0a.39.39,0,0,1,.27.45h0a.37.37,0,0,1-.36.28h-.09ZM279.76,330a.37.37,0,0,1,.22-.48h0a.37.37,0,0,1,.48.2h0a.36.36,0,0,1-.22.48h0a.2.2,0,0,1-.13,0h0a.39.39,0,0,1-.35-.2Zm126.49-.65a.37.37,0,0,1,.26-.47h0a.39.39,0,0,1,.46.26h0a.38.38,0,0,1-.26.46h-.1a.36.36,0,0,1-.36-.28Zm-21.6-.13h0a.37.37,0,0,1-.23-.47h0a.39.39,0,0,1,.48-.23h0a.38.38,0,0,1,.23.48h0a.37.37,0,0,1-.36.24h0a.23.23,0,0,1-.12-.05Zm-101.49-.7a.37.37,0,0,1,.16-.5h0a.38.38,0,0,1,.5.17h0a.37.37,0,0,1-.16.5h0a.33.33,0,0,1-.17,0h0a.37.37,0,0,1-.33-.2Zm126.63-.26a.37.37,0,0,1,.22-.47h0a.37.37,0,0,1,.47.23h0a.37.37,0,0,1-.23.48h-.12a.39.39,0,0,1-.34-.27Zm-28.59-.46h0a.36.36,0,0,1-.18-.49h0a.37.37,0,0,1,.49-.18h0a.37.37,0,0,1,.18.5h0a.38.38,0,0,1-.34.22h0a.27.27,0,0,1-.15-.08Zm32.06-.85a.36.36,0,0,1,.2-.48h0a.35.35,0,0,1,.48.2h0a.37.37,0,0,1-.19.49h0a.359.359,0,0,1-.14,0h0a.37.37,0,0,1-.35-.24Zm-126.87-.22a.39.39,0,0,1,.12-.52h0a.36.36,0,0,1,.51.12h0a.36.36,0,0,1-.12.51h0a.28.28,0,0,1-.19.07h0a.41.41,0,0,1-.32-.21Zm91.48-.6h0a.38.38,0,0,1-.15-.51h0a.37.37,0,0,1,.51-.14h0a.36.36,0,0,1,.14.5h0a.37.37,0,0,1-.32.2h0a.61.61,0,0,1-.18-.08Zm38.78-.68a.36.36,0,0,1,.18-.49h0a.38.38,0,0,1,.5.18h0a.37.37,0,0,1-.19.49h0a.45.45,0,0,1-.16,0h0a.36.36,0,0,1-.33-.21Zm-127.18-.77a.37.37,0,0,1,.09-.52h0a.38.38,0,0,1,.52.07h0a.38.38,0,0,1-.09.53h0a.41.41,0,0,1-.22.07h0a.37.37,0,0,1-.3-.18Zm85.18-.42h0a.36.36,0,0,1-.12-.5h0a.35.35,0,0,1,.5-.13h0a.36.36,0,0,1,.13.51h0a.37.37,0,0,1-.31.19h0a.34.34,0,0,1-.2-.1Zm45.32-.46a.38.38,0,0,1,.15-.51h0a.38.38,0,0,1,.51.16h0a.38.38,0,0,1-.16.51h0a.53.53,0,0,1-.17,0h0a.38.38,0,0,1-.3-.19Zm-127.53-1.36a.37.37,0,0,1,.05-.52h0a.39.39,0,0,1,.53.05h0a.39.39,0,0,1-.06.54h0a.4.4,0,0,1-.24.07h0a.31.31,0,0,1-.28-.17Zm79.07-.16h0a.37.37,0,0,1-.11-.52h0a.39.39,0,0,1,.52-.11h0a.39.39,0,0,1,.11.52h0a.37.37,0,0,1-.32.17h0a.46.46,0,0,1-.2-.09Zm51.7-.28a.37.37,0,0,1,.13-.51h0a.4.4,0,0,1,.52.13h0a.4.4,0,0,1-.13.52h0a.49.49,0,0,1-.2.05h0a.38.38,0,0,1-.32-.19Zm-54.79-1.79a.37.37,0,0,1-.1-.52h0a.39.39,0,0,1,.52-.1h0a.39.39,0,0,1,.1.53h0a.42.42,0,0,1-.32.16h0a.32.32,0,0,1-.2-.1Zm58-.13a.38.38,0,0,1,.12-.52h0a.36.36,0,0,1,.51.12h0a.36.36,0,0,1-.12.51h0a.26.26,0,0,1-.19.07h0a.41.41,0,0,1-.36-.21Zm-131.07,0a.38.38,0,0,1,0-.52h0a.4.4,0,0,1,.54,0h0a.37.37,0,0,1-.06.53h0a.34.34,0,0,1-.24.09h0a.4.4,0,0,1-.28-.11ZM429.49,318a.37.37,0,0,1,.09-.52h0a.36.36,0,0,1,.52.1h0a.36.36,0,0,1-.1.51h0a.4.4,0,0,1-.2.07h0a.38.38,0,0,1-.31-.16Zm-64.14.09a.35.35,0,0,1-.1-.51h0a.36.36,0,0,1,.51-.11h0a.36.36,0,0,1,.1.52h0a.34.34,0,0,1-.3.17h0a.4.4,0,0,1-.21-.05Zm-67.19-.42a.36.36,0,0,1,0-.52h0a.39.39,0,0,1,.53,0h0a.38.38,0,0,1-.05.53h0a.36.36,0,0,1-.24.09h0a.35.35,0,0,1-.24-.08Zm64.11-1.63a.37.37,0,0,1-.11-.52h0a.36.36,0,0,1,.51-.11h0a.37.37,0,0,1,.11.52h0a.33.33,0,0,1-.3.16h0a.36.36,0,0,1-.21-.03Zm70.26-.18a.35.35,0,0,1,.07-.51h0a.38.38,0,0,1,.53.08h0a.38.38,0,0,1-.09.52h0a.44.44,0,0,1-.22.07h0a.33.33,0,0,1-.29-.14ZM301,315.33a.38.38,0,0,1,.05-.53h0a.38.38,0,0,1,.53.06h0a.36.36,0,0,1-.06.52h0a.3.3,0,0,1-.24.09h0A.38.38,0,0,1,301,315.33Zm58.15-1.27a.36.36,0,0,1-.12-.51h0a.36.36,0,0,1,.51-.12h0a.36.36,0,0,1,.12.51h0a.38.38,0,0,1-.32.18h0a.33.33,0,0,1-.18-.06Zm76.34-.39a.38.38,0,0,1,.06-.53h0a.36.36,0,0,1,.52.07h0a.38.38,0,0,1-.06.52h0a.32.32,0,0,1-.22.08h0a.37.37,0,0,1-.29-.14ZM303.91,313a.38.38,0,0,1,.08-.52h0a.37.37,0,0,1,.52.08h0a.38.38,0,0,1-.07.52h0a.45.45,0,0,1-.22.08h0a.4.4,0,0,1-.31-.16Zm52.07-.86a.37.37,0,0,1-.13-.51h0a.35.35,0,0,1,.5-.13h0a.35.35,0,0,1,.14.5h0a.36.36,0,0,1-.32.19h0a.491.491,0,0,1-.17-.02Zm82.41-.82a.37.37,0,0,1,.05-.52h0a.38.38,0,0,1,.53.05h0a.38.38,0,0,1-.05.53h0a.43.43,0,0,1-.24.08h0a.35.35,0,0,1-.29-.11Zm-131.46-.48a.37.37,0,0,1,.09-.52h0a.39.39,0,0,1,.53.11h0a.37.37,0,0,1-.11.51h0a.4.4,0,0,1-.21.07h0a.36.36,0,0,1-.3-.14Zm45.81-.46a.36.36,0,0,1-.15-.5h0a.36.36,0,0,1,.5-.16h0a.4.4,0,0,1,.16.51h0a.4.4,0,0,1-.34.2h0a.28.28,0,0,1-.17-.02ZM441.23,309a.37.37,0,0,1,0-.52h0a.39.39,0,0,1,.53,0h0a.38.38,0,0,1-.05.52h0a.31.31,0,0,1-.24.1h0a.34.34,0,0,1-.24-.1Zm-131.17-.06a.38.38,0,0,1,.14-.52h0a.37.37,0,0,1,.5.14h0a.38.38,0,0,1-.14.52h0a.42.42,0,0,1-.18,0h0a.4.4,0,0,1-.32-.18Zm39.36-.07h0a.38.38,0,0,1-.19-.49h0a.37.37,0,0,1,.49-.19h0a.36.36,0,0,1,.19.49h0a.38.38,0,0,1-.34.22h0a.4.4,0,0,1-.15-.07ZM346,307.44a.37.37,0,0,1-.22-.48h0a.4.4,0,0,1,.48-.22h0a.38.38,0,0,1,.22.48h0a.35.35,0,0,1-.35.24h0A.32.32,0,0,1,346,307.44Zm-32.67-.26a.38.38,0,0,1,.18-.49h0a.37.37,0,0,1,.5.18h0a.39.39,0,0,1-.19.5h0a.41.41,0,0,1-.16,0h0a.36.36,0,0,1-.32-.19Zm29.18-.88a.38.38,0,0,1-.25-.47h0a.37.37,0,0,1,.47-.25h0a.38.38,0,0,1,.25.47h0a.4.4,0,0,1-.36.26h-.11Zm-25.76-.52a.39.39,0,0,1,.24-.47h0a.38.38,0,0,1,.47.24h0a.36.36,0,0,1-.24.47h0a.35.35,0,0,1-.12,0h0a.38.38,0,0,1-.34-.24Zm22.2-.39a.36.36,0,0,1-.28-.44h0a.36.36,0,0,1,.44-.28h0a.37.37,0,0,1,.29.44h0a.38.38,0,0,1-.37.29H339Zm-18.65-.62a.38.38,0,0,1,.3-.45h0a.37.37,0,0,1,.43.28h0a.36.36,0,0,1-.28.45h-.08a.39.39,0,0,1-.36-.28Zm15,0h0a.39.39,0,0,1-.32-.43h0a.36.36,0,0,1,.41-.32h0a.39.39,0,0,1,.32.43h0a.38.38,0,0,1-.37.32h0Zm-11.3-.64a.37.37,0,0,1,.33-.4h0a.36.36,0,0,1,.41.33h0a.38.38,0,0,1-.34.41h0a.37.37,0,0,1-.4-.34Zm7.73.24h0a.36.36,0,0,1-.35-.39h0a.37.37,0,0,1,.39-.35h0a.38.38,0,0,1,.35.41h0a.37.37,0,0,1-.37.35h0Zm-4-.48a.36.36,0,0,1,.37-.37h0a.37.37,0,0,1,.37.37h0a.37.37,0,0,1-.37.38h0a.37.37,0,0,1-.45-.38Z"
                    fill="#707272"
                />
                <path
                    id="Path_79"
                    data-name="Path 79"
                    d="M254.64,329.33a.35.35,0,0,1-.14,0,.26.26,0,0,1-.12-.09.21.21,0,0,1-.08-.12.29.29,0,0,1,0-.14.38.38,0,0,1,.11-.26.32.32,0,0,1,.12-.08.34.34,0,0,1,.28,0,.21.21,0,0,1,.12.08.34.34,0,0,1,.11.26.3.3,0,0,1,0,.14.19.19,0,0,1-.09.12.22.22,0,0,1-.12.09.29.29,0,0,1-.19,0Z"
                    fill="#707272"
                />
                <path
                    id="Path_80"
                    data-name="Path 80"
                    d="M314.51,217.53h0L312,214.79a25,25,0,0,1-17,6.83,21.36,21.36,0,0,1-21.31-17.3l-3.82,1h0l-3.49.92a28.17,28.17,0,0,0,7,13.79C284.4,232,304.05,232,316.84,220Z"
                    fill="#f4f5f6"
                />
                <path
                    id="Path_81"
                    data-name="Path 81"
                    d="M320,176.52l-3.34,3.12h0l-2.3,2.15A21.67,21.67,0,0,1,320,198.28a25.11,25.11,0,0,1-8,16.51l2,2.15h0l2.88,3.1a33.21,33.21,0,0,0,10.57-21.76A28.79,28.79,0,0,0,320,176.52Z"
                    fill="#707272"
                />
                <path
                    id="Path_82"
                    data-name="Path 82"
                    d="M320,176.52c-11.08-11.92-30.73-11.92-43.52,0-8.31,7.77-12.17,19.12-10.09,29.73l4.32-1.14h0l3-.79a23.159,23.159,0,0,1-.35-6,25.48,25.48,0,0,1,25-23.33,21.59,21.59,0,0,1,16,6.84l2.95-2.76h0Z"
                    fill="#e4e3e3"
                />
                <path
                    id="Path_83"
                    data-name="Path 83"
                    d="M351.31,217.53h0l2.95-2.74a21.77,21.77,0,0,1-5.65-16.51,25.58,25.58,0,0,1,18.91-22.54l-.74-3.75h0l-.67-3.43a33.74,33.74,0,0,0-14.36,8C339,188.46,337.54,208.1,348.63,220Z"
                    fill="#f4f5f6"
                />
                <path
                    id="Path_84"
                    data-name="Path 84"
                    d="M392.14,220l-2.89-3.11h0l-2-2.15a25,25,0,0,1-17,6.84,21.63,21.63,0,0,1-16-6.83L352,216.94h0l-3.32,3.1a28.59,28.59,0,0,0,21.11,9A33.05,33.05,0,0,0,392.14,220Z"
                    fill="#707272"
                />
                <path
                    id="Path_85"
                    data-name="Path 85"
                    d="M392.14,220c12.79-11.94,14.19-31.58,3.12-43.52-7.21-7.75-18.34-10.8-29.15-8l.83,4.24h0l.58,2.94a24.23,24.23,0,0,1,6.1-.78,21.42,21.42,0,0,1,21.65,23.32,25.1,25.1,0,0,1-8,16.5l2.55,2.75h0Z"
                    fill="#e4e3e3"
                />
                <path
                    id="Path_86"
                    data-name="Path 86"
                    d="M443.71,170.26a2.16,2.16,0,0,1,1.6.68,2.19,2.19,0,0,1,.57,1.65l-1.35,18.84a2.74,2.74,0,0,1-2.65,2.47H423a2.16,2.16,0,0,1-1.6-.68,2.2,2.2,0,0,1-.57-1.66l1.35-18.83a2.75,2.75,0,0,1,2.66-2.47h18.83m0-1H424.88a3.7,3.7,0,0,0-3.62,3.37l-1.35,18.84a3.11,3.11,0,0,0,3.13,3.37h18.84a3.69,3.69,0,0,0,3.61-3.37l1.35-18.84a3.11,3.11,0,0,0-3.13-3.37Z"
                    fill="#e4e3e3"
                />
                <path
                    id="Path_87"
                    data-name="Path 87"
                    d="M441.39,202.66a2.13,2.13,0,0,1,2.16,2.34l-1.35,18.83a2.74,2.74,0,0,1-2.65,2.48H420.72a2.16,2.16,0,0,1-1.6-.68,2.2,2.2,0,0,1-.57-1.66l1.35-18.83a2.74,2.74,0,0,1,2.65-2.48h18.84m0-1H422.55a3.68,3.68,0,0,0-3.61,3.37l-1.35,18.83a3.11,3.11,0,0,0,3.13,3.37h18.83a3.7,3.7,0,0,0,3.62-3.37l1.35-18.83a3.1,3.1,0,0,0-3.13-3.37Z"
                    fill="#e4e3e3"
                />
                <path
                    id="Path_88"
                    data-name="Path 88"
                    d="M413.82,306.86a1.83,1.83,0,0,1,1.34.57,1.81,1.81,0,0,1,.48,1.4,2.3,2.3,0,0,1-2.25,2.1,1.8,1.8,0,0,1-1.83-2,2.32,2.32,0,0,1,2.26-2.11m0-1a3.28,3.28,0,0,0-3.22,3,2.76,2.76,0,0,0,2.79,3,3.28,3.28,0,0,0,3.21-3,2.75,2.75,0,0,0-2.78-3Z"
                    fill="#5274b8"
                />
                <path
                    id="Path_89"
                    data-name="Path 89"
                    d="M414.06,305.92l-.49-.04.07-.96.48.04Z"
                    fill="#5274b8"
                />
                <path
                    id="Path_90"
                    data-name="Path 90"
                    d="M414.27,303h-.48l.14-2h.48Zm.28-3.94h-.48l.14-2h.48Zm.28-3.94h-.48l.14-2h.48Zm.28-4h-.48l.14-2h.48Zm.29-3.94h-.48l.14-2h.48Zm.28-3.94h-.48l.14-2h.48Zm.28-3.95h-.48l.14-2h.48Zm.28-3.94h-.48l.14-2h.48Zm.29-3.94h-.48l.14-2h.48Zm.28-3.95h-.48l.14-2h.48Zm.28-3.94h-.48l.14-2h.48Z"
                    fill="#5274b8"
                />
                <rect
                    id="Rectangle_21"
                    data-name="Rectangle 21"
                    width="0.96"
                    height="0.48"
                    transform="matrix(0.071, -0.997, 0.997, 0.071, 416.882, 259.564)"
                    fill="#5274b8"
                />
                <path
                    id="Path_91"
                    data-name="Path 91"
                    d="M437.55,259.15H264.67a3.4,3.4,0,0,1-3.42-3.68l.85-11.9A4,4,0,0,1,266,240H438.85a3.4,3.4,0,0,1,3.42,3.68l-.85,11.9A4,4,0,0,1,437.55,259.15ZM266,241a2.88,2.88,0,0,0-2.82,2.64l-.86,11.9a2.4,2.4,0,0,0,.63,1.82,2.37,2.37,0,0,0,1.75.75H437.55a2.89,2.89,0,0,0,2.83-2.64l.85-11.9a2.35,2.35,0,0,0-2.38-2.57Z"
                    fill="#707272"
                />
                <path
                    id="Path_92"
                    data-name="Path 92"
                    d="M433.84,247.63H270a1.49,1.49,0,0,1-1.5-1.62h0a1.77,1.77,0,0,1,1.73-1.62H434.07a1.5,1.5,0,0,1,1.51,1.62h0a1.78,1.78,0,0,1-1.74,1.62Z"
                    fill="#e4e3e3"
                    fillRule="evenodd"
                />
                <path
                    id="Path_93"
                    data-name="Path 93"
                    d="M406.53,254.46H269.47a1.49,1.49,0,0,1-1.5-1.62h0a1.77,1.77,0,0,1,1.73-1.62H406.76a1.49,1.49,0,0,1,1.5,1.62h0A1.77,1.77,0,0,1,406.53,254.46Z"
                    fill="#e4e3e3"
                    fillRule="evenodd"
                />
                <circle
                    id="Ellipse_1"
                    data-name="Ellipse 1"
                    cx="10.11"
                    cy="10.11"
                    r="10.11"
                    transform="translate(486.4 322.07)"
                    fill="#fff"
                    stroke="#e2e2e2"
                    strokeMiterlimit="10"
                    strokeWidth="2"
                />
                <circle
                    id="Ellipse_2"
                    data-name="Ellipse 2"
                    cx="6.65"
                    cy="6.65"
                    r="6.65"
                    transform="translate(489.86 113)"
                    fill="#fff"
                    stroke="#e2e2e2"
                    strokeMiterlimit="10"
                    strokeWidth="2"
                />
                <circle
                    id="Ellipse_3"
                    data-name="Ellipse 3"
                    cx="11.15"
                    cy="11.15"
                    r="11.15"
                    transform="translate(4.91 357.5)"
                    fill="#fff"
                    stroke="#e2e2e2"
                    strokeMiterlimit="10"
                    strokeWidth="2"
                />
                <path
                    id="Path_94"
                    data-name="Path 94"
                    d="M33.19,97.19H26V90a.89.89,0,0,0-.89-.9h0a.92.92,0,0,0-.92.9v7.2H17a.92.92,0,0,0-.91.92A.91.91,0,0,0,17,99h7.19v7.22a.91.91,0,0,0,.92.89.89.89,0,0,0,.89-.89h0V99h7.22a.9.9,0,0,0,.9-.89.92.92,0,0,0-.93-.92Z"
                    fill="#e2e2e2"
                    stroke="#e2e2e2"
                    strokeMiterlimit="10"
                    strokeWidth="0.75"
                />
                <path
                    id="Path_95"
                    data-name="Path 95"
                    d="M347.53,61h-7.22V53.8a.89.89,0,0,0-.89-.9h0a.92.92,0,0,0-.92.9V61h-7.19a.91.91,0,1,0,0,1.81h7.19v7.21a.92.92,0,0,0,.92.9.89.89,0,0,0,.89-.9h0V62.84h7.22a.91.91,0,0,0,0-1.81Z"
                    fill="#e2e2e2"
                    stroke="#e2e2e2"
                    strokeMiterlimit="10"
                    strokeWidth="0.75"
                />
            </g>
        </SVGIcon>
    );
}
